<template>
  <div class="product-subscription-manager" :class="{ 'product-subscription-manager--embedded': embedded }">
    <template v-if="!embedded">
      <h5 class="font-weight-bold">اشتراک های محصول</h5>
      <p class="font-weight-bold">
        در صورت انتخاب اشتراک قیمت محصول از اشتراک انتخابی محاسبه میشود.
      </p>
    </template>

    <div class="overflow_div">
      <form @submit.prevent="searchSubscriptions">
        <div class="selected-subscriptions">
          <template v-if="!embedded">
            <span v-for="item in productSubscriptions"
                  :key="item.id"
                  @click="deleteItem(item)"
                  class="badge badge-primary cursor-pointer m-1">{{ item.subscription.name }} {{
                item.subscription_item.name
              }}</span>
          </template>

          <div class="col-12 selected-category-section" :class="{ 'mt-3': !embedded }">
            <label v-if="!embedded">
              اشترک های محصول
              <b-icon
                  icon="arrow-clockwise"
                  class="d-inline"
                  @click="refreshSubscriptions"
              ></b-icon>
            </label>

            <b-form-input
                id="input"
                v-model="searchedWord"
                placeholder=" جستجو"
                class="mb-1"
                @keypress.enter.prevent="searchSubscriptions"
            ></b-form-input>
          </div>
        </div>
      </form>

      <div class="subscriptions">
        <div class="cursor-pointer" v-for="subscription in subscriptions" :key="subscription.id">
          <div v-if="subscription.subscription_items.length > 0">
            <div
                class="subscription-item"
                v-for="sub_subscription in subscription.subscription_items"
                :key="sub_subscription.id"
                @click="addSubscriptionToProduct(sub_subscription)">
              {{ subscription.name }} - {{ sub_subscription.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "ProductSubscriptionManager",
  props: {
    product: {},
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchedWord: '',
      subscriptions: []
    };
  },
  computed: {
    productSubscriptions() {
      return this.product.subscriptions ?? []
    }
  },
  methods: {
    refreshSubscriptions() {
      this.$store.commit('Subscription/setFilters', {key: 'search', value: ''})
      this.loadSubscriptions()
    },
    loadSubscriptions() {
      let req = this.$store.dispatch('Subscription/getSubscriptions')
      req.then(res => {
        this.subscriptions = res.data.data.data
      })
    },
    deleteItem(item) {

      if (confirm('آیا از حذف اطمینان دارید؟')) {
        this.$store.dispatch('Subscription/deleteProductSubscription', item).then(res => {
          let indexOfItem = this.productSubscriptions.map(item => item.id).indexOf(item.id)
          this.productSubscriptions.splice(indexOfItem, 1)
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        })
      }

    },
    searchSubscriptions() {
      this.$store.commit('Subscription/setFilters', {key: 'search', value: this.searchedWord})
      this.loadSubscriptions()
    },
    addSubscriptionToProduct(item) {
      let form = {
        product_id: this.product.id,
        subscription_item_id: item.id
      }
      this.$store.dispatch('Subscription/addSubscriptionToProduct', form).then(res => {

        this.$store.dispatch('Subscription/getProductSubscriptions', {id: this.product.id}).then(res => {
          this.product.subscriptions = res.data.data
        })
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')

      })
    }
  },
  mounted() {
    this.loadSubscriptions()
  }
};
</script>

<style scoped>
.product-subscription-manager:not(.product-subscription-manager--embedded) {
  background: #d1ecf1;
  border-radius: 0.25rem;
  padding: 1rem;
}

.overflow_div {
  height: 350px;
  overflow: auto;
}

.product-subscription-manager--embedded,
.product-subscription-manager--embedded .overflow_div {
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.product-subscription-manager--embedded .overflow_div {
  overflow-y: auto;
}

.selected-subscriptions {
  position: sticky;
  top: 0;
  background-color: #ececed;
  padding: 10px;
  border-bottom: 1px solid rgba(30, 30, 30, 0.08);
  z-index: 2;
}

.subscription-item {
  padding: 0.55rem 0.75rem;
  border-bottom: 1px solid rgba(30, 30, 30, 0.06);
}

.subscription-item:hover {
  background: rgba(235, 61, 96, 0.08);
  color: #d12d50;
}
</style>
